import {useContext, useState} from "react";
import AppContext from "../context/AppContext";
import {Link} from "react-router-dom";
import './ProcessListBubble.scss'

export default () => {
    const { processList } = useContext(AppContext)
    const [expanded, setExpanded] = useState(true)

    if (!processList || (!processList.processing.length && !processList.queued)) {
        return null
    }

    const activeCount = processList.processing.length + processList.queued

    return (
        <div className="plb">
            <div className="plb-header" onClick={() => setExpanded(e => !e)}>
                <span className="plb-spinner"/>
                <span className="plb-title">
                    Indexing · {activeCount} file{activeCount !== 1 ? 's' : ''}
                </span>
                <Link className="plb-details" to="/queue" onClick={e => e.stopPropagation()}>details</Link>
                <span className="plb-chevron">{expanded ? '▾' : '▸'}</span>
            </div>

            {expanded && (
                <div className="plb-body">
                    {processList.processing.map(entry => {
                        const status = entry.videoStatus || entry.photoStatus
                        const name = entry.path.split('/').pop() || entry.path
                        const pct = status?.percent ?? 0
                        return (
                            <div key={entry.path} className="plb-entry">
                                <div className="plb-row">
                                    <span className="plb-name" title={entry.path}>{name}</span>
                                    {status && <span className="plb-pct">{pct}%</span>}
                                </div>
                                {status?.currentAction && (
                                    <div className="plb-action">{status.currentAction}</div>
                                )}
                                <div className="plb-track">
                                    <div className="plb-bar" style={{ width: `${pct}%` }}/>
                                </div>
                            </div>
                        )
                    })}

                    {processList.queued > 0 && (
                        <div className="plb-queue-count">
                            +{processList.queued} waiting in queue
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}
